<div class="brackets-auth-layout tw-min-h-screen tw-flex tw-flex-col lg:tw-flex-row">
  <aside
    class="brackets-auth-layout__hero tw-relative tw-hidden lg:tw-flex lg:tw-w-[44%] xl:tw-w-[42%] tw-shrink-0 tw-overflow-hidden tw-mt-4 tw-ml-2 tw-mb-2 tw-mr-0 tw-rounded-3xl"
    aria-hidden="true"
  >
    <img
      src="images/login/login.png"
      alt=""
      class="tw-absolute tw-inset-0 tw-size-full tw-object-cover"
    />
  </aside>

  <main
    class="brackets-auth-layout__main tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-px-6 tw-py-8 sm:tw-px-10 lg:tw-py-12 tw-bg-background"
  >
    <div class="brackets-auth-layout__panel tw-w-full tw-max-w-[420px] tw-mx-auto">
      <a
        routerLink="/"
        class="brackets-auth-layout__logo tw-flex tw-justify-center tw-w-full -tw-mt-4 tw-mb-12"
      >
        <img
          src="images/logo.png"
          alt="BracketsVault"
          class="brackets-auth-layout__logo-img tw-h-16 sm:tw-h-[4.5rem] tw-w-auto"
        />
      </a>

      @if (pageTitle) {
        <h1
          bitTypography="h1"
          class="brackets-auth-layout__title tw-mb-2 tw-text-main tw-text-center tw-w-full"
        >
          {{ pageTitle }}
        </h1>
      }

      @if (pageSubtitle?.trim()) {
        <p
          bitTypography="body1"
          class="brackets-auth-layout__subtitle tw-mb-6 tw-text-main tw-text-center tw-w-full"
        >
          {{ pageSubtitle }}
        </p>
      }

      <div class="brackets-auth-layout__secondary tw-mb-6 tw-text-main tw-text-center tw-w-full">
        <router-outlet name="secondary"></router-outlet>
      </div>

      <div class="brackets-auth-layout__content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>
